import React from 'react'
import { Link } from 'react-router'
import IconSVG from 'svg-inline-react'
import classnames from 'classnames'
import driftLogoSrc from '!svg-inline?removeTags=true!images/Drift-full.svg'
import style from './style.styl'

const HeaderBrand = ({ large }) => {
  return (
    <Link to="/">
      <div className={classnames(style.HeaderBrand, { large: large })}>
        <IconSVG src={driftLogoSrc} />
      </div>
    </Link>
  )
}

export default HeaderBrand



// WEBPACK FOOTER //
// ./src/scripts/components/nav/Header/HeaderBrand/index.js